import React, { useState, useEffect } from "react";
import { Tabs, Tab } from "react-bootstrap";
import Applications from "./Applications";
import CheckApplications from "./simplecheck/Applications";
import SpectApplications from "./simplespect/Applications";
import axiosInstance from "../../utils/axiosInstance";
import { useNavigate, useLocation } from "react-router-dom";

import { useAuth } from "../../contexts/AuthContext";

function CommunityDashboard() {
  const { userDetail } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const communityName = location.state?.communityName || "Community Dashboard";
  
  const [accessFlags, setAccessFlags] = useState({
    hasPermit: userDetail?.role === "Admin" || !!userDetail?.hasSimplePermit,
    hasCheck: userDetail?.role === "Admin" || !!userDetail?.hasSimpleCheck,
    hasSpect: userDetail?.role === "Admin" || !!userDetail?.hasSimpleSpect,
  });

  const [key, setKey] = useState("permit");
  const [permitCount, setPermitCount] = useState(0);
  const [checkCount, setCheckCount] = useState(0);
  const [spectCount, setSpectCount] = useState(0);

  useEffect(() => {
    if (userDetail?.role === "Community") {
      axiosInstance.get("/communities/me")
        .then((res) => {
          const { hasSimplePermit, hasSimpleCheck, hasSimpleSpect } = res.data;
          setAccessFlags({
            hasPermit: !!hasSimplePermit,
            hasCheck: !!hasSimpleCheck,
            hasSpect: !!hasSimpleSpect,
          });
          
          // Update default tab if permit is not accessible
          if (!hasSimplePermit) {
            if (hasSimpleCheck) setKey("check");
            else if (hasSimpleSpect) setKey("spect");
          }
        })
        .catch(console.error);
    } else {
      // Set initial key based on initial access flags
      if (!accessFlags.hasPermit) {
        if (accessFlags.hasCheck) setKey("check");
        else if (accessFlags.hasSpect) setKey("spect");
      }
    }
  }, [userDetail]);

  const { hasPermit, hasCheck, hasSpect } = accessFlags;

  return (
    <div className="subMain-content">
      {userDetail?.role === "Admin" && (
        <div className="mb-4 mt-3 text-start">
          <button 
            className="btn btn-sm btn-outline-secondary mb-3" 
            onClick={() => navigate("/admin/communities")}
            style={{ display: "inline-flex", alignItems: "center", gap: "0.3rem", fontWeight: "500" }}
          >
            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="currentColor" viewBox="0 0 16 16">
              <path fillRule="evenodd" d="M15 8a.5.5 0 0 0-.5-.5H2.707l3.147-3.146a.5.5 0 1 0-.708-.708l-4 4a.5.5 0 0 0 0 .708l4 4a.5.5 0 0 0 .708-.708L2.707 8.5H14.5A.5.5 0 0 0 15 8z"/>
            </svg>
            Back to Communities
          </button>
          
          {communityName !== "Community Dashboard" && (
            <h2 className="mb-0 fw-bold text-dark" style={{ letterSpacing: "-0.025em" }}>
              {communityName}
            </h2>
          )}
        </div>
      )}
      <Tabs
        id="community-dashboard-tabs"
        activeKey={key}
        onSelect={(k) => setKey(k)}
        className="mb-4"
      >
        {hasPermit && (
          <Tab eventKey="permit" title="SimplePermit">
            <Applications isTab={true} onCountChange={setPermitCount} />
          </Tab>
        )}
        {hasCheck && (
          <Tab eventKey="check" title="SimpleCheck">
            <CheckApplications isTab={true} onCountChange={setCheckCount} />
          </Tab>
        )}
        {hasSpect && (
          <Tab eventKey="spect" title="SimpleSpect">
            <SpectApplications isTab={true} onCountChange={setSpectCount} />
          </Tab>
        )}
      </Tabs>
    </div>
  );
}

export default CommunityDashboard;
